import { injectable } from 'inversify';

export interface IMobileService {
  shouldDisplayInstallNotice(callback: Function): void;
  fakeiPhone(): void;
}

@injectable()
export class MobileService implements IMobileService {
  public shouldDisplayInstallNotice(callback: Function) {
    const iOS = this.isiOS();
    const safari = this.isSafari();
    const touch = this.isTouch();
    const standAlone = this.isStandalone();
    if ((iOS || (safari && touch)) && !standAlone) {
      callback();
    }
  }

  public fakeiPhone() {
    Object.defineProperty(window.navigator, 'platform', {
      get: function () {
        return 'iPhone';
      }
    });
  }

  private isiOS() {
    return ['iPhone', 'iPad', 'iPod'].includes(navigator.platform);
  }
  private isSafari() {
    return navigator.userAgent.search("Safari") >= 0 && navigator.userAgent.search("Chrome") < 0;
  }
  private isTouch() {
    return 'ontouchstart' in window;
  }
  private isStandalone() {
    return (window.matchMedia('(display-mode: standalone)').matches);
  }
}
